import React, {Component} from 'react';

import "./DocumentList.css"
import "./commonAnalysisStyle.css"
import $ from "jquery";
import {render, unmountComponentAtNode} from 'react-dom';


import Document from './Document';
import * as moment from 'moment'
import 'moment/locale/it'

class Item extends Component {
    constructor(props) {
        super(props);
        moment.locale('it');
        let m = moment(props.date);
        let data = m.format('MMMM YYYY')

        if (props.date.split('-').length > 2) {
            data = m.format('LL')
        } else if (props.date.replace('--', '').length === 4) {
            data = m.format('YYYY')
        }
        this.state = {backgroundColor: '#000000', filterString: undefined, filterDate: undefined, stile: ""};
        this.state.contentHtml = <div title={data} className={"item_list"} onClick={() => this.loadDocument()}>
            <span>{this.props.title}</span>
        </div>
    }


    loadDocument() {
        unmountComponentAtNode(document.getElementById("document_viewer"))
        render(<Document id={this.props.id}/>, document.getElementById("document_viewer"))
    }

    hideMe() {
        this.setState({visibility: false})
        //console.log(this.props.title)
    }

    showMe() {
        this.setState({visibility: true})
    }


    render() {
        return (
            <div>
                {this.state.contentHtml}
            </div>
        )
    }
}


class DocumentList extends Component {

    clusterize = undefined

    constructor(props) {
        super(props);
        this.state = {
            items: [],
            visibleItems: [],
            getItems: this.getFileListFromDB
        };


    }


    getFileListLemmaByYear(parameters, callback) {
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileListLemma",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {

                //console.log(data)
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });
        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })
    }


    getFileListFromDBKeyword(parameters, callback) {
        // "loadFileListKeyword", range, null, this.category
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileListKeyword",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {

                //console.log(data)
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });
        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }

    getFileListFromDBEntities(parameters, callback) {
        // "loadFileListKeyword", range, null, this.category
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileListEntity",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {

                //console.log(data)
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });
        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }

    getFileListFromDBPerson(parameters, callback) {
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileListFromPersonEntities",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {
                //console.log(data)
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });
        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }

    getFileListFromDBLemma(parameters, callback) {
        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "serachFreqOfTerms",
            data: parameters,
            async: false,
            dataType: "json",
            success: function (data) {


                //console.log(data)
                // data.forEach((i) => {
                //     elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                // })
            }
        });
        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }


    getFileListFromDBGeoCited(parameters, callback) {

        let data = []
        let elements = []
        parameters.fileList.forEach((i) => {
            data.push(JSON.parse(i));
        })


        data.forEach((i) => {
            elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
        })


        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }


    getFileListFromDBGeo(parameters, callback) {
        let param = parameters
        if (param == undefined) {
            param = {
                corpusID: "deg",
                rangeYears: "all",
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: []
            }
        }

        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileListGeo",
            data: param,
            async: false,
            dataType: "json",
            success: function (data) {
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });

        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }


    getFileListFromDB(parameters, callback) {
        let param = parameters
        if (param == undefined) {
            param = {
                corpusID: "deg",
                rangeYears: "all",
                sortmethod: "dataInsertion",
                sortdirection: "ASC",
                fileList: []
            }
        }

        let elements = []
        $.ajax({
            type: "POST",
            url: window.apiAlcideUrlPrefix + "loadFileList",
            data: param,
            async: false,
            dataType: "json",
            success: function (data) {
                data.forEach((i) => {
                    elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
                })
            }
        });

        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })

    }

    setFileListFromJson(parameters, callback) {
        let elements = [];
        parameters.data.forEach((i) => {
            elements.push(<Item key={i.id} id={i.id} date={i.date} location={i.location} title={i.title}/>)
        })

        this.setState({background: parameters.background})

        this.setState({items: elements}, () => {
            callback()
        })
    }


    componentDidMount() {
        if (this.state.items.length === 0) {
            // console.log("empty list");
            // fetch from db\
        }
        document.getElementById("DocListSearchBox").style.height = '0px'
    }


    filterItems(event) {
        let string = event.target.value;
        if (string.length > 2) {
            this.setState({filterString: string});
        } else {
            this.setState({filterString: undefined});
        }
    }

    filterItemsByYear(year) {
        this.setState({filterDate: year});

    }


    render() {
        return (<div>
                <div className="col-header"><span id='numResults'>Totale Documenti:{(this.state.items.filter(item => {

                    if (this.state.filterString === undefined && this.state.filterDate === undefined) {
                        return true;
                    } else {
                        let titleFilter = true;
                        let dateFilter = true;
                        if (this.state.filterString !== undefined) {
                            titleFilter = item.props.title.toLowerCase().includes(this.state.filterString.toLowerCase());
                        }

                        if (this.state.filterDate !== undefined) {
                            dateFilter = item.props.date.toLowerCase().startsWith(this.state.filterDate.toString());
                        }

                        return titleFilter && dateFilter
                    }
                })).length}</span>
                    <div><i className="fa fa-search" style={{marginLeft: '8px', marginRight: '8px'}} onClick={() => {
                        document.getElementById("DocListSearchBox").style.height === '0px' ? document.getElementById("DocListSearchBox").style.height = '52px' : document.getElementById("DocListSearchBox").style.height = '0px'
                        document.getElementById('search').focus();
                        document.getElementById('search').select();
                    }}/></div>
                </div>
                <div className="colScrollable" style={{backgroundColor: this.state.background}}>
                    <div id="DocListSearchBox" className="box">
                        <div className="container-4">
                            <form>
                                <input type="search" id="search" placeholder="Cerca nei titoli..." onBlur={() => {
                                    document.getElementById("DocListSearchBox").style.height = '0px'
                                }} onChange={this.filterItems.bind(this)}/>
                                <button className="icon"><i className="fa fa-search"/></button>
                            </form>
                        </div>
                    </div>


                    <div className="commonAnalysisFeatures" style={{backgroundColor: this.state.background, paddingTop: "15px"}}>

                        <h1 className={"title"}>Risultati</h1>
                        <div id="scrollArea" className="clusterize-scroll list">
                            <div id="contentArea" className="clusterize-content">
                                {this.state.items.filter(item => {

                                    if (this.state.filterString === undefined && this.state.filterDate === undefined) {
                                        return true;
                                    } else {
                                        let titleFilter = true;
                                        let dateFilter = true;
                                        if (this.state.filterString !== undefined) {
                                            titleFilter = item.props.title.toLowerCase().includes(this.state.filterString.toLowerCase());
                                        }

                                        if (this.state.filterDate !== undefined) {
                                            dateFilter = item.props.date.toLowerCase().startsWith(this.state.filterDate.toString());
                                        }

                                        return titleFilter && dateFilter
                                    }
                                })

                                }
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default DocumentList;


// WEBPACK FOOTER //
// ./src/components/DocumentList.jsx